module.exports = __webpack_public_path__ + "static/secondary-prevention-data-0c821bdb21cf37f0b82db5e4c7046d8c.png";